/**
 * Dashboard v2 - Gestione gridstack, edit mode, salvataggio layout, widget picker.
 * Dipende da: jQuery, GridStack (globali da bootstrap.js), window.DashboardV2Config (dalla view).
 */
(function () {
    var MAX_CONFIG_RETRIES = 50;
    var configRetries = 0;

    // fix: BRAIN-5G — evita href malformati (es. literal js/'+t.project_url+') nel drilldown TNGP
    function escapeHtml(value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function safeProjectHref(projectUrl) {
        if (!projectUrl || typeof projectUrl !== 'string') {
            return '';
        }
        if (/^https?:\/\//i.test(projectUrl) || projectUrl.charAt(0) === '/') {
            return projectUrl;
        }

        return '';
    }

    function init() {
        if (typeof $ === 'undefined') {
            return;
        }
        var $gridEl = $('#dashboard-v2-grid');
        if (!$gridEl.length) {
            return;
        }
        if (typeof window.DashboardV2Config === 'undefined') {
            if (configRetries++ < MAX_CONFIG_RETRIES) {
                setTimeout(init, 150);
            }
            return;
        }

        var config = window.DashboardV2Config;
        var isEditMode = false;
        var grid = null;
        var layoutSnapshotAtEditStart = null;

        // null = aggiunta alla griglia principale
        // { widgetId: string, tabIndex: number } = aggiunta dentro un tab specifico
        var tabPickerContext = null;

        function initGrid() {
            grid = GridStack.init({
                column: 12,
                animate: true,
                staticGrid: true,
                handle: '.dashboard-v2-widget-heading',
                cellHeight: 10,
                verticalMargin: 10,
                float: false
            }, '#dashboard-v2-grid');
        }

        function doExitEditMode() {
            isEditMode = false;
            layoutSnapshotAtEditStart = null;
            if (grid) {
                grid.setStatic(true);
            }
            $('#dashboard-v2-toggle-edit .btn-edit-label').text('Personalizza');
            $('#dashboard-v2-save-layout').hide();
            $('#dashboard-v2-add-widget-fab').hide();
            $('.dashboard-v2-widget-remove').hide();
            $('.dashboard-v2-tab-add-li').hide();
            $('.dashboard-v2-tab-add-widget-wrap').hide();
            $('.dashboard-v2-tab-widget-remove').hide();
            $('.chatCallout').show();
            autoResizeWidgets();
        }

        function toggleEditMode() {
            if (isEditMode) {
                var current = JSON.stringify(serializeLayout());
                if (current !== layoutSnapshotAtEditStart && typeof Swal !== 'undefined') {
                    Swal.fire({
                        title: 'Modifiche non salvate',
                        text: 'Hai modificato il layout senza salvare. Uscire comunque?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Esci',
                        cancelButtonText: 'Annulla'
                    }).then(function (result) {
                        if (result.isConfirmed) {
                            doExitEditMode();
                        }
                    });
                    return;
                }
                doExitEditMode();
                return;
            }

            isEditMode = true;
            layoutSnapshotAtEditStart = JSON.stringify(serializeLayout());
            if (grid) {
                grid.setStatic(false);
            }
            $('#dashboard-v2-toggle-edit .btn-edit-label').text('Esci da personalizzazione');
            $('#dashboard-v2-save-layout').show();
            $('#dashboard-v2-add-widget-fab').show();
            $('.dashboard-v2-widget-remove').show();
            $('.dashboard-v2-tab-add-li').show();
            $('.dashboard-v2-tab-add-widget-wrap').show();
            $('.dashboard-v2-tab-widget-remove').show();
            $('.chatCallout').hide();
        }

        // ==================== Serializzazione layout ====================

        function readTabDataFromDom($gridItem) {
            var tabs = [];
            var $container = $gridItem.find('.dashboard-v2-tab-container').first();
            if (!$container.length) {
                return tabs;
            }
            $container.find('.tab-pane').each(function () {
                var $pane = $(this);
                var $navLink = $container.find('a[href="#' + $pane.attr('id') + '"] .dashboard-v2-tab-label');
                var name = $navLink.length ? $navLink.text().trim() : 'Tab';
                var widgets = [];
                $pane.find('.dashboard-v2-tab-widget').each(function () {
                    var t = $(this).attr('data-widget-type');
                    var w = parseInt($(this).attr('data-widget-w'), 10) || 12;
                    if (t) {
                        widgets.push({ type: t, w: w });
                    }
                });
                tabs.push({ name: name, widgets: widgets });
            });
            return tabs;
        }

        function syncTabData($gridItem) {
            var tabs = readTabDataFromDom($gridItem);
            $gridItem.attr('data-widget-tabs', JSON.stringify(tabs));
        }

        function serializeLayout() {
            var items = [];
            $gridEl.find('.grid-stack-item').each(function () {
                var $item = $(this);
                var node = $item.data('_gridstack_node') || {};
                var id = $item.attr('data-gs-id');
                var type = $item.attr('data-widget-type');
                if (!id || !type) {
                    return;
                }
                var obj = {
                    id: id,
                    type: type,
                    x: node.x !== undefined ? node.x : (parseInt($item.attr('data-gs-x'), 10) || 0),
                    y: node.y !== undefined ? node.y : (parseInt($item.attr('data-gs-y'), 10) || 0),
                    w: node.width !== undefined ? node.width : (parseInt($item.attr('data-gs-width'), 10) || 4),
                    h: node.height !== undefined ? node.height : (parseInt($item.attr('data-gs-height'), 10) || 3)
                };
                if (type === 'tab_container') {
                    obj.tabs = readTabDataFromDom($item);
                }
                items.push(obj);
            });
            return items;
        }

        function saveLayout() {
            var items = serializeLayout();
            $.ajax({
                url: config.saveLayoutUrl,
                method: 'POST',
                data: { _token: config.csrfToken, widgets: items },
                contentType: 'application/x-www-form-urlencoded',
                success: function () {
                    layoutSnapshotAtEditStart = JSON.stringify(serializeLayout());
                    if (typeof Swal !== 'undefined') {
                        Swal.fire({ icon: 'success', title: 'Salvato', text: 'Layout salvato.' });
                    } else if (typeof window.toastr !== 'undefined') {
                        window.toastr.success('Layout salvato.');
                    } else {
                        alert('Layout salvato.');
                    }
                },
                error: function () {
                    if (typeof Swal !== 'undefined') {
                        Swal.fire({ icon: 'error', title: 'Errore', text: 'Errore nel salvataggio del layout.' });
                    } else if (typeof window.toastr !== 'undefined') {
                        window.toastr.error('Errore nel salvataggio.');
                    } else {
                        alert('Errore nel salvataggio del layout.');
                    }
                }
            });
        }

        // ==================== Widget grid principale ====================

        function removeWidget(widgetId) {
            var $item = $gridEl.find('.grid-stack-item[data-gs-id="' + widgetId + '"]');
            if ($item.length && grid) {
                try {
                    // Gridstack 1.x: removeWidget(el, removeDOM=true, triggerEvent=true).
                    // Passare removeDOM=true altrimenti il widget resta visibile al primo click
                    // (veniva tolto solo dall'engine logico e sembrava che il click non avesse effetto).
                    grid.removeWidget($item.get(0), true);
                } catch (e) {
                    $item.remove();
                }
            }
        }

        function addWidgetToGrid(widgetId, widgetType, w, h) {
            var def = config.widgetCatalog[widgetType];
            if (!def) {
                return;
            }
            var url = typeof getWidgetFetchUrl === 'function' ? getWidgetFetchUrl(widgetType) : config.widgetHtmlUrl.replace('__ID__', widgetType);
            if (typeof getWidgetFetchUrl !== 'function' && config.filterParams && config.filterParams.ws) {
                url += (url.indexOf('?') >= 0 ? '&' : '?') + 'ws=' + encodeURIComponent(config.filterParams.ws);
            }
            $.get(url, function (data) {
                if (!data.html) {
                    return;
                }
                var nextY = 0;
                $gridEl.find('.grid-stack-item').each(function () {
                    var node = $(this).data('_gridstack_node') || {};
                    var bottom = (node.y || 0) + (node.height || 1);
                    if (bottom > nextY) {
                        nextY = bottom;
                    }
                });
                var newId = 'w_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
                var name = def.name || widgetType;
                var icon = def.icon || 'fa-square';
                var html = '<div class="grid-stack-item-content">' +
                    '<div class="panel panel-info dashboard-v2-widget-panel">' +
                    '<div class="panel-heading dashboard-v2-widget-heading" style="display: flex; justify-content: space-between; align-items: center;">' +
                    '<span><i class="fa ' + icon + '"></i> ' + name + '</span>' +
                    '<button type="button" class="btn btn-danger btn-xs dashboard-v2-widget-remove" data-widget-id="' + newId + '" title="Rimuovi widget"><i class="fa fa-times"></i></button>' +
                    '</div>' +
                    '<div class="panel-body" style="padding: 15px 0 0 0;">' + data.html + '</div>' +
                    '</div>' +
                    '</div>';
                var $newEl = $('<div class="grid-stack-item" data-gs-id="' + newId + '" data-widget-type="' + widgetType + '">' + html + '</div>');
                if (grid) {
                    grid.addWidget($newEl.get(0), { x: 0, y: nextY, width: w, height: h, autoPosition: false });
                }
                $newEl.find('.dashboard-v2-widget-remove').on('click', function () {
                    removeWidget(newId);
                });
                if (window.chartsHandler && typeof window.chartsHandler.initializeCharts === 'function') {
                    window.chartsHandler.initializeCharts();
                }
                if (typeof window.mountDashboardMyBrainIn === 'function') {
                    var $nb = $newEl.find('.panel-body').first();
                    if ($nb.length) {
                        window.mountDashboardMyBrainIn($nb[0]);
                    }
                }
                setTimeout(autoResizeWidgets, 300);
                setTimeout(autoResizeWidgets, 1500);
            }).fail(function () {
                if (typeof window.toastr !== 'undefined') {
                    window.toastr.error('Impossibile caricare il widget.');
                } else {
                    alert('Impossibile caricare il widget.');
                }
            });
        }

        // ==================== Tab Container ====================

        function addEmptyTabContainer() {
            var defaultTabs = [
                { name: 'Tab 1', widgets: [] },
                { name: 'Tab 2', widgets: [] },
                { name: 'Tab 3', widgets: [] }
            ];
            var url = typeof getWidgetFetchUrl === 'function' ? getWidgetFetchUrl('tab_container') : config.widgetHtmlUrl.replace('__ID__', 'tab_container');
            $.ajax({
                url: url,
                method: 'POST',
                data: { _token: config.csrfToken, tabs_json: JSON.stringify(defaultTabs), active_tab: 0 },
                success: function (data) {
                    if (!data.html) {
                        return;
                    }
                    var nextY = 0;
                    $gridEl.find('.grid-stack-item').each(function () {
                        var node = $(this).data('_gridstack_node') || {};
                        var bottom = (node.y || 0) + (node.height || 1);
                        if (bottom > nextY) {
                            nextY = bottom;
                        }
                    });
                    var newId = 'w_' + Date.now() + '_tab';
                    var def = config.widgetCatalog['tab_container'] || {};
                    var name = def.name || 'Modulo Tab';
                    var icon = def.icon || 'fa-folder-o';
                    var html = '<div class="grid-stack-item-content">' +
                        '<div class="panel panel-info dashboard-v2-widget-panel">' +
                        '<div class="panel-heading dashboard-v2-widget-heading" style="display: flex; justify-content: space-between; align-items: center;">' +
                        '<span><i class="fa ' + icon + '"></i> ' + name + '</span>' +
                        '<button type="button" class="btn btn-danger btn-xs dashboard-v2-widget-remove" data-widget-id="' + newId + '" title="Rimuovi widget"><i class="fa fa-times"></i></button>' +
                        '</div>' +
                        '<div class="panel-body" style="padding: 15px 0 0 0;">' + data.html + '</div>' +
                        '</div>' +
                        '</div>';
                    var tabsJson = JSON.stringify(defaultTabs).replace(/"/g, '&quot;');
                    var $newEl = $('<div class="grid-stack-item" data-gs-id="' + newId + '" data-widget-type="tab_container" data-widget-tabs="' + tabsJson + '">' + html + '</div>');
                    if (grid) {
                        grid.addWidget($newEl.get(0), { x: 0, y: nextY, width: 12, height: 25, autoPosition: false });
                    }
                    $newEl.find('.dashboard-v2-widget-remove').on('click', function () {
                        removeWidget(newId);
                    });
                    if (isEditMode) {
                        $newEl.find('.dashboard-v2-tab-add-li').show();
                        $newEl.find('.dashboard-v2-tab-add-widget-wrap').show();
                    }
                    setTimeout(autoResizeWidgets, 300);
                    setTimeout(autoResizeWidgets, 1500);
                    $('#dashboard-v2-widget-picker-modal').modal('hide');
                },
                error: function () {
                    if (typeof window.toastr !== 'undefined') {
                        window.toastr.error('Impossibile creare il modulo tab.');
                    } else {
                        alert('Impossibile creare il modulo tab.');
                    }
                }
            });
        }

        function addNewTab($container) {
            var $gridItem = $container.closest('.grid-stack-item');
            var tabWidgetId = $container.attr('data-tab-widget-id');
            var tabCount = $container.find('.tab-pane').length;
            var newIndex = tabCount;
            var newName = 'Tab ' + (newIndex + 1);
            var paneId = tabWidgetId + '_tab_' + newIndex;

            var $addLi = $container.find('.dashboard-v2-tab-add-li');
            var $newLi = $('<li role="presentation"><a href="#' + paneId + '" role="tab" data-toggle="tab"><span class="dashboard-v2-tab-label">' + newName + '</span></a></li>');
            $addLi.before($newLi);

            var showAdd = isEditMode ? '' : 'display: none; ';
            var $newPane = $(
                '<div role="tabpanel" class="tab-pane" id="' + paneId + '" data-tab-index="' + newIndex + '">' +
                '<div class="row dashboard-v2-tab-widgets-row"></div>' +
                '<div class="dashboard-v2-tab-add-widget-wrap" style="' + showAdd + 'text-align: center; padding: 15px 0;">' +
                '<button type="button" class="btn btn-default btn-sm dashboard-v2-tab-add-widget" data-tab-index="' + newIndex + '">' +
                '<i class="fa fa-plus"></i> Aggiungi widget a questo tab</button></div>' +
                '</div>'
            );
            $container.find('.tab-content').append($newPane);
            $newLi.find('a').tab('show');
            syncTabData($gridItem);
        }

        function removeTabWidget($btn) {
            var $widget = $btn.closest('.dashboard-v2-tab-widget');
            var $gridItem = $widget.closest('.grid-stack-item');
            $widget.remove();
            syncTabData($gridItem);
            setTimeout(autoResizeWidgets, 200);
        }

        function renameTab($label) {
            var currentName = $label.text().trim();
            var $input = $('<input type="text" class="form-control input-sm dashboard-v2-tab-rename-input" style="display: inline-block; width: 120px; height: 22px; padding: 1px 4px; font-size: 12px;">');
            $input.val(currentName);
            $label.hide().after($input);
            $input.focus().select();

            function commitRename() {
                var newName = $input.val().trim() || currentName;
                $label.text(newName).show();
                $input.remove();
                var $gridItem = $label.closest('.grid-stack-item');
                if ($gridItem.length) {
                    syncTabData($gridItem);
                }
            }

            $input.on('blur', commitRename);
            $input.on('keydown', function (e) {
                if (e.which === 13) {
                    commitRename();
                }
                if (e.which === 27) {
                    $label.show();
                    $input.remove();
                }
            });
        }

        // ==================== Widget Picker ====================

        function switchPickerCategory(category) {
            var $modal = $('#dashboard-v2-widget-picker-modal');
            $modal.find('.dashboard-v2-picker-sidebar li').removeClass('active');
            $modal.find('.dashboard-v2-picker-cat-link[data-category="' + category + '"]').closest('li').addClass('active');
            $modal.find('.dashboard-v2-picker-panel').hide();
            $modal.find('.dashboard-v2-picker-panel[data-panel="' + category + '"]').show();
        }

        function getExistingWidgetTypes() {
            var types = {};
            $gridEl.find('.grid-stack-item').each(function () {
                var t = $(this).attr('data-widget-type');
                if (t) {
                    types[t] = true;
                }
            });
            return types;
        }

        function getExistingTabWidgetTypes($gridItem, tabIndex) {
            var types = {};
            var $pane = $gridItem.find('.tab-pane[data-tab-index="' + tabIndex + '"]');
            $pane.find('.dashboard-v2-tab-widget').each(function () {
                var t = $(this).attr('data-widget-type');
                if (t) {
                    types[t] = true;
                }
            });
            return types;
        }

        function openWidgetPicker() {
            tabPickerContext = null;
            var $modal = $('#dashboard-v2-widget-picker-modal');
            var existing = getExistingWidgetTypes();
            $modal.find('.dashboard-v2-picker-checkbox').each(function () {
                $(this).prop('checked', !!existing[$(this).val()]);
            });
            $modal.find('.dashboard-v2-picker-cat-link[data-category="tab_creator"]').closest('li').show();
            var firstCat = $modal.find('.dashboard-v2-picker-cat-link').first().attr('data-category');
            if (firstCat) {
                switchPickerCategory(firstCat);
            }
            $modal.find('.modal-title').html('<i class="fa fa-th-large"></i> Aggiungi widget');
            $modal.modal('show');
        }

        function openTabWidgetPicker(gridItemId, tabIndex) {
            tabPickerContext = { widgetId: gridItemId, tabIndex: tabIndex };
            var $gridItem = $gridEl.find('.grid-stack-item[data-gs-id="' + gridItemId + '"]');
            var existing = getExistingTabWidgetTypes($gridItem, tabIndex);
            var $modal = $('#dashboard-v2-widget-picker-modal');
            $modal.find('.dashboard-v2-picker-checkbox').each(function () {
                $(this).prop('checked', !!existing[$(this).val()]);
            });
            $modal.find('.dashboard-v2-picker-cat-link[data-category="tab_creator"]').closest('li').hide();
            var $container = $gridItem.find('.dashboard-v2-tab-container').first();
            var $pane = $container.find('.tab-pane[data-tab-index="' + tabIndex + '"]');
            var tabName = $container.find('a[href="#' + $pane.attr('id') + '"] .dashboard-v2-tab-label').text().trim() || ('Tab ' + (tabIndex + 1));
            var firstCat = $modal.find('.dashboard-v2-picker-cat-link:visible').first().attr('data-category');
            if (firstCat) {
                switchPickerCategory(firstCat);
            }
            $modal.find('.modal-title').html('<i class="fa fa-th-large"></i> Aggiungi widget a: <strong>' + tabName + '</strong>');
            $modal.modal('show');
        }

        function addSelectedWidgets() {
            if (tabPickerContext) {
                addSelectedWidgetsToTab();
            } else {
                addSelectedWidgetsToGrid();
            }
        }

        function addSelectedWidgetsToGrid() {
            var existing = getExistingWidgetTypes();
            var toAdd = [];
            var toRemove = [];
            $('#dashboard-v2-widget-picker-modal .dashboard-v2-picker-checkbox').each(function () {
                var type = $(this).val();
                var checked = $(this).is(':checked');
                if (checked && !existing[type]) {
                    var $row = $(this).closest('.dashboard-v2-picker-widget');
                    var w = parseInt($row.find('.dashboard-v2-picker-width').val(), 10) || 4;
                    var h = parseInt($row.attr('data-widget-h'), 10) || 3;
                    toAdd.push({ type: type, w: Math.min(12, Math.max(1, w)), h: h });
                } else if (!checked && existing[type]) {
                    toRemove.push(type);
                }
            });
            toRemove.forEach(function (type) {
                $gridEl.find('.grid-stack-item[data-widget-type="' + type + '"]').each(function () {
                    var id = $(this).attr('data-gs-id');
                    if (id) {
                        removeWidget(id);
                    }
                });
            });
            toAdd.forEach(function (item, idx) {
                var def = config.widgetCatalog[item.type];
                if (!def) {
                    return;
                }
                addWidgetToGrid('w_' + Date.now() + '_' + idx, item.type, item.w, item.h);
            });
            if (toAdd.length === 0 && toRemove.length === 0) {
                return;
            }
            $('#dashboard-v2-widget-picker-modal').modal('hide');
        }

        function addSelectedWidgetsToTab() {
            var ctx = tabPickerContext;
            if (!ctx) {
                return;
            }
            var $gridItem = $gridEl.find('.grid-stack-item[data-gs-id="' + ctx.widgetId + '"]');
            if (!$gridItem.length) {
                return;
            }
            var existing = getExistingTabWidgetTypes($gridItem, ctx.tabIndex);
            var toAdd = [];
            var toRemove = [];
            $('#dashboard-v2-widget-picker-modal .dashboard-v2-picker-checkbox').each(function () {
                var type = $(this).val();
                var checked = $(this).is(':checked');
                if (checked && !existing[type]) {
                    var $row = $(this).closest('.dashboard-v2-picker-widget');
                    var w = parseInt($row.find('.dashboard-v2-picker-width').val(), 10) || 4;
                    toAdd.push({ type: type, w: Math.min(12, Math.max(1, w)) });
                } else if (!checked && existing[type]) {
                    toRemove.push(type);
                }
            });

            var $container = $gridItem.find('.dashboard-v2-tab-container').first();
            var $pane = $container.find('.tab-pane[data-tab-index="' + ctx.tabIndex + '"]');
            var $widgetsRow = $pane.find('.dashboard-v2-tab-widgets-row').first();

            toRemove.forEach(function (type) {
                $widgetsRow.find('.dashboard-v2-tab-widget[data-widget-type="' + type + '"]').remove();
            });

            if (toAdd.length === 0 && toRemove.length === 0) {
                return;
            }

            if (toAdd.length > 0) {
                var queue = toAdd.slice();
                function processNext() {
                    if (queue.length === 0) {
                        syncTabData($gridItem);
                        setTimeout(autoResizeWidgets, 300);
                        setTimeout(autoResizeWidgets, 1500);
                        $('#dashboard-v2-widget-picker-modal').modal('hide');
                        return;
                    }
                    var item = queue.shift();
                    var url = getWidgetFetchUrl(item.type);
                    $.get(url, function (data) {
                        if (data.html) {
                            var showRemove = isEditMode ? '' : 'display: none; ';
                            var removeBtn = '<button type="button" class="btn btn-danger btn-xs dashboard-v2-tab-widget-remove" ' +
                                'style="' + showRemove + 'position: absolute; top: 2px; right: 17px; z-index: 10;" title="Rimuovi">' +
                                '<i class="fa fa-times"></i></button>';
                            var $widget = $('<div class="col-md-' + item.w + ' dashboard-v2-tab-widget" ' +
                                'data-widget-type="' + item.type + '" data-widget-w="' + item.w + '" ' +
                                'style="margin-bottom: 15px; position: relative;">' +
                                removeBtn + data.html + '</div>');
                            $widgetsRow.append($widget);
                            if (typeof window.mountDashboardMyBrainIn === 'function') {
                                window.mountDashboardMyBrainIn($widget[0]);
                            }
                        }
                        processNext();
                    }).fail(processNext);
                }
                processNext();
            } else {
                syncTabData($gridItem);
                setTimeout(autoResizeWidgets, 300);
                $('#dashboard-v2-widget-picker-modal').modal('hide');
            }
        }

        // ==================== Auto resize ====================

        function autoResizeWidgets() {
            if (!grid) {
                return;
            }
            var cellH = 10;
            var margin = 10;
            var unitH = cellH + margin;

            $gridEl.find('.grid-stack-item').each(function () {
                var $item = $(this);
                var $content = $item.children('.grid-stack-item-content');
                var $panel = $item.find('.dashboard-v2-widget-panel');
                if (!$panel.length || !$content.length) {
                    return;
                }

                var contentEl = $content[0];
                var savedPos = contentEl.style.position;
                var savedTop = contentEl.style.top;
                var savedBottom = contentEl.style.bottom;
                contentEl.style.position = 'static';
                contentEl.style.top = 'auto';
                contentEl.style.bottom = 'auto';

                var naturalHeight = $panel[0].offsetHeight;

                contentEl.style.position = savedPos;
                contentEl.style.top = savedTop;
                contentEl.style.bottom = savedBottom;

                if (naturalHeight < 20) {
                    return;
                }

                var neededH = Math.max(2, Math.ceil((naturalHeight + margin) / unitH));

                var node = $item.data('_gridstack_node');
                var currentH = node ? node.height : (parseInt($item.attr('data-gs-height'), 10) || 3);

                if (neededH !== currentH) {
                    grid.resize($item.get(0), null, neededH);
                }
            });
        }

        function scheduleAutoResize() {
            autoResizeWidgets();
            setTimeout(autoResizeWidgets, 500);
            setTimeout(autoResizeWidgets, 1500);
            setTimeout(autoResizeWidgets, 3000);
        }

        // ==================== Async Widget Loading ====================

        function getWidgetFetchUrl(widgetType, tabs) {
            var url = config.widgetHtmlUrl.replace('__ID__', widgetType);
            var params = config.filterParams || {};
            var qs = [];
            if (params.company) qs.push('company=' + encodeURIComponent(params.company));
            if (params.year) qs.push('year=' + encodeURIComponent(params.year));
            if (params.group) qs.push('group=' + encodeURIComponent(params.group));
            if (params.ws) qs.push('ws=' + encodeURIComponent(params.ws));
            if (qs.length) url += (url.indexOf('?') >= 0 ? '&' : '?') + qs.join('&');
            return url;
        }

        /**
         * Fetch widget JSON con retry su {retry:true} (cache in rebuild).
         * Usa Deferred esplicito (niente .then filter): con minify/Webpack il typeof
         * helper può collidere e la catena then/done non aggiorna il DOM.
         */
        function fetchWidgetJson(url, options, attempt) {
            attempt = attempt || 0;
            var maxAttempts = 40;
            var master = $.Deferred();
            var ajaxOpts = $.extend({ url: url, dataType: 'json' }, options || {});

            function markBuilding() {
                if (attempt > 0) {
                    return;
                }
                $('.dashboard-v2-widget-loading').filter(':visible').each(function () {
                    var $el = $(this);
                    if (!$el.data('buildingMsg')) {
                        $el.data('buildingMsg', true);
                        $el.html('<i class="fa fa-spinner fa-spin"></i> Preparazione dati…');
                    }
                });
            }

            function scheduleRetry() {
                markBuilding();
                var delayMs = Math.min(2000, 400 + attempt * 150);
                setTimeout(function () {
                    fetchWidgetJson(url, options, attempt + 1).then(master.resolve, master.reject);
                }, delayMs);
            }

            $.ajax(ajaxOpts)
                .done(function (data) {
                    if (data && typeof data === 'object' && data.retry === true) {
                        if (attempt >= maxAttempts) {
                            master.reject({ status: 0, responseJSON: data });
                            return;
                        }
                        scheduleRetry();
                        return;
                    }
                    master.resolve(data);
                })
                .fail(function (xhr) {
                    var payload = null;
                    try {
                        payload = xhr && xhr.responseJSON ? xhr.responseJSON : JSON.parse(xhr.responseText || '{}');
                    } catch (e) {
                        payload = null;
                    }
                    var shouldRetry = payload && payload.retry === true && (
                        (xhr && xhr.status === 503) ||
                        (xhr && xhr.status === 0) ||
                        (xhr && xhr.status === 200)
                    );
                    if (!shouldRetry || attempt >= maxAttempts) {
                        master.reject(xhr);
                        return;
                    }
                    scheduleRetry();
                });

            return master.promise();
        }

        function initTngpCruscottoBlocks($root) {
            var $scope = $root && $root.length ? $root : $(document);
            $scope.find('.tngp-cruscotto-block').each(function () {
                var $block = $(this);
                if ($block.data('tngpInit')) {
                    return;
                }
                $block.data('tngpInit', true);
                var blockId = $block.data('tngpBlockId');
                var savedAgg = blockId ? localStorage.getItem('tngp-agg-' + blockId) : null;
                if (savedAgg && ['month', 'quarter', 'total'].indexOf(savedAgg) !== -1) {
                    $block.attr('data-aggregation', savedAgg);
                    $block.find('.tngp-aggregation-toggle .btn').removeClass('active');
                    $block.find('.tngp-aggregation-toggle .btn[data-aggregation="' + savedAgg + '"]').addClass('active');
                }
            });
        }

        function resolveWidgetTabs($body) {
            var fromBody = $body.attr('data-widget-tabs');
            if (fromBody) {
                return parseWidgetTabsAttribute(fromBody);
            }
            var fromItem = $body.closest('.grid-stack-item').attr('data-widget-tabs');
            return parseWidgetTabsAttribute(fromItem);
        }

        /**
         * Carica un widget async. Restituisce la promise (per il pool parallelo).
         * IMPORTANTE: widgetType/widgetDomId/tabs devono essere catturati per chiamata
         * (parametri di funzione), mai letti da var condivise in un while+XHR.
         */
        function loadWidgetAsync($body, widgetType, widgetId, tabs) {
            var url = getWidgetFetchUrl(widgetType, tabs);
            var widgetDomId = $body.attr('data-widget-id') || widgetId;
            var reqData = { _token: config.csrfToken };
            if (widgetType === 'tab_container' && tabs && tabs.length) {
                reqData.tabs_json = JSON.stringify(tabs);
                reqData.active_tab = 0;
            }
            var isPost = widgetType === 'tab_container' && tabs && tabs.length;
            var req = isPost
                ? fetchWidgetJson(url, { method: 'POST', data: reqData })
                : fetchWidgetJson(url, { method: 'GET' });

            req.done(function (data) {
                var $target = widgetDomId
                    ? $gridEl.find('.dashboard-v2-widget-body[data-widget-id="' + widgetDomId + '"]').first()
                    : $body;
                if (!$target.length) {
                    $target = $body;
                }
                var html = (data && typeof data === 'object' && data.html) ? data.html : null;
                if (!html || typeof html !== 'string') {
                    $target.html('<div class="text-muted text-center" style="padding: 20px;"><i class="fa fa-exclamation-triangle"></i> Widget non disponibile</div>');
                    return;
                }
                var $loading = $target.find('.dashboard-v2-widget-loading').first();
                if ($loading.length) {
                    $loading.replaceWith(html);
                } else {
                    $target.html(html);
                }
                if (window.chartsHandler && typeof window.chartsHandler.initializeCharts === 'function') {
                    window.chartsHandler.initializeCharts();
                }
                if (typeof window.mountDashboardMyBrainIn === 'function') {
                    window.mountDashboardMyBrainIn($target[0]);
                }
                initTngpCruscottoBlocks($target);
                bindLazyTabLoading($target);
                scheduleAutoResize();
            }).fail(function () {
                var $target = widgetDomId
                    ? $gridEl.find('.dashboard-v2-widget-body[data-widget-id="' + widgetDomId + '"]').first()
                    : $body;
                if (!$target.length) {
                    $target = $body;
                }
                var errHtml = '<div class="text-danger text-center" style="padding: 20px;"><i class="fa fa-exclamation-circle"></i> Errore caricamento widget</div>';
                var $loading = $target.find('.dashboard-v2-widget-loading').first();
                if ($loading.length) {
                    $loading.replaceWith(errHtml);
                } else {
                    $target.html(errHtml);
                }
            });

            return req;
        }

        function bindLazyTabLoading($root) {
            $root.find('.dashboard-v2-tab-container').each(function () {
                var $container = $(this);
                if ($container.data('lazyTabsBound')) {
                    return;
                }
                $container.data('lazyTabsBound', true);
                $container.on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
                    var target = $(e.target).attr('href');
                    if (!target) {
                        return;
                    }
                    var $pane = $container.find(target);
                    if (!$pane.length || !$pane.attr('data-lazy-tab')) {
                        return;
                    }
                    loadLazyTabPane($pane);
                });
            });
        }

        function loadLazyTabPane($pane) {
            if ($pane.data('lazyLoading') || $pane.data('lazyLoaded')) {
                return;
            }
            $pane.data('lazyLoading', true);
            var queue = [];
            $pane.find('.dashboard-v2-tab-widget').each(function () {
                var $wrap = $(this);
                if ($wrap.find('[data-lazy-widget]').length === 0) {
                    return;
                }
                queue.push($wrap);
            });

            if (queue.length === 0) {
                $pane.removeAttr('data-lazy-tab');
                $pane.data('lazyLoaded', true);
                $pane.data('lazyLoading', false);
                return;
            }

            var remaining = queue.length;
            queue.forEach(function ($wrap) {
                var widgetType = $wrap.attr('data-widget-type');
                var url = getWidgetFetchUrl(widgetType);
                fetchWidgetJson(url, { method: 'GET' }).done(function (data) {
                    var html = (data && typeof data === 'object' && data.html) ? data.html : null;
                    if (html && typeof html === 'string') {
                        $wrap.find('[data-lazy-widget]').replaceWith(html);
                        if (window.chartsHandler && typeof window.chartsHandler.initializeCharts === 'function') {
                            window.chartsHandler.initializeCharts();
                        }
                        if (typeof window.mountDashboardMyBrainIn === 'function') {
                            window.mountDashboardMyBrainIn($wrap[0]);
                        }
                        initTngpCruscottoBlocks($wrap);
                    } else {
                        $wrap.find('[data-lazy-widget]').replaceWith(
                            '<div class="text-muted text-center" style="padding: 20px;">Widget non disponibile</div>'
                        );
                    }
                }).fail(function () {
                    $wrap.find('[data-lazy-widget]').replaceWith(
                        '<div class="text-danger text-center" style="padding: 20px;">Errore caricamento</div>'
                    );
                }).always(function () {
                    remaining--;
                    if (remaining <= 0) {
                        $pane.removeAttr('data-lazy-tab');
                        $pane.data('lazyLoaded', true);
                        $pane.data('lazyLoading', false);
                        scheduleAutoResize();
                    }
                });
            });
        }

        function parseWidgetTabsAttribute(tabsJson) {
            if (!tabsJson) {
                return null;
            }
            try {
                var normalized = String(tabsJson)
                    .replace(/&quot;/g, '"')
                    .replace(/&#039;/g, "'")
                    .replace(/&#39;/g, "'")
                    .replace(/&amp;/g, '&')
                    .replace(/&lt;/g, '<')
                    .replace(/&gt;/g, '>');
                var parsed = JSON.parse(normalized);
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return [];
            }
        }

        function loadAllWidgetsAsync() {
            var MAX_PARALLEL = 3;
            var $pending = $gridEl.find('.dashboard-v2-widget-body').filter(function () {
                return $(this).find('.dashboard-v2-widget-loading').length > 0;
            });

            // Tab container prima (KPI pesanti), poi gli altri — ma con pool limitato:
            // senza tetto, 11 XHR in parallelo fanno stampede su MySQL/FPM a cache fredda.
            var queue = [];
            $pending.filter('[data-widget-type="tab_container"]').each(function () {
                queue.push($(this));
            });
            $pending.not('[data-widget-type="tab_container"]').each(function () {
                queue.push($(this));
            });

            var inFlight = 0;

            function pump() {
                while (inFlight < MAX_PARALLEL && queue.length > 0) {
                    // Cattura per iterazione: con `var` nel while le XHR parallele
                    // condividevano widgetDomId e finivano tutte sull'ultimo body (es. Confermate).
                    (function ($body) {
                        inFlight++;
                        var widgetType = $body.attr('data-widget-type');
                        var widgetDomId = $body.attr('data-widget-id');
                        var tabs = resolveWidgetTabs($body);
                        loadWidgetAsync($body, widgetType, widgetDomId, tabs).always(function () {
                            inFlight--;
                            pump();
                        });
                    })(queue.shift());
                }
            }

            pump();
        }

        // ==================== Init & Event Binding ====================

        initGrid();
        initTngpCruscottoBlocks($('#dashboard-v2-grid'));
        if (config.asyncLoad) {
            loadAllWidgetsAsync();
        }
        scheduleAutoResize();

        $(window).on('load', function () {
            autoResizeWidgets();
        });

        $('#dashboard-v2-toggle-edit').on('click', toggleEditMode);
        $('#dashboard-v2-save-layout').on('click', saveLayout);

        $('#dashboard-v2-reset-layout').on('click', function () {
            if (!config.resetLayoutUrl) {
                return;
            }
            if (typeof Swal !== 'undefined') {
                Swal.fire({
                    title: 'Ripristinare il layout?',
                    text: 'Verranno ripristinati i widget predefiniti per questo workspace.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sì, ripristina',
                    cancelButtonText: 'Annulla'
                }).then(function (result) {
                    if (!result.isConfirmed) {
                        return;
                    }
                    $.ajax({
                        url: config.resetLayoutUrl,
                        method: 'POST',
                        data: { _token: config.csrfToken },
                        success: function () {
                            window.location.reload();
                        },
                        error: function () {
                            Swal.fire({ icon: 'error', title: 'Errore', text: 'Impossibile ripristinare il layout.' });
                        }
                    });
                });
            } else if (window.confirm('Ripristinare il layout predefinito?')) {
                $.ajax({
                    url: config.resetLayoutUrl,
                    method: 'POST',
                    data: { _token: config.csrfToken },
                    success: function () {
                        window.location.reload();
                    }
                });
            }
        });
        $('#dashboard-v2-add-widget-fab').on('click', openWidgetPicker);

        $(document).on('click', '#dashboard-v2-picker-add-selected', addSelectedWidgets);
        $(document).on('click', '.dashboard-v2-picker-cat-link', function (e) {
            e.preventDefault();
            var cat = $(this).attr('data-category');
            if (cat) {
                switchPickerCategory(cat);
            }
        });

        $(document).on('click', '.dashboard-v2-widget-remove', function () {
            var id = $(this).data('widget-id');
            if (id) {
                removeWidget(id);
            }
        });

        $(document).on('shown.bs.tab', '.dashboard-v2-tab-container a[data-toggle="tab"]', function () {
            autoResizeWidgets();
            setTimeout(autoResizeWidgets, 500);
        });

        $('#dashboard-v2-add-tab-container').on('click', addEmptyTabContainer);

        $(document).on('click', '.dashboard-v2-tab-add-widget', function () {
            var tabIndex = parseInt($(this).attr('data-tab-index'), 10);
            var gridItemId = $(this).closest('.grid-stack-item').attr('data-gs-id');
            if (gridItemId !== undefined && !isNaN(tabIndex)) {
                openTabWidgetPicker(gridItemId, tabIndex);
            }
        });

        $(document).on('click', '.dashboard-v2-tab-widget-remove', function (e) {
            e.stopPropagation();
            removeTabWidget($(this));
        });

        $(document).on('click', '.dashboard-v2-tab-add-btn', function (e) {
            e.preventDefault();
            var $container = $(this).closest('.dashboard-v2-tab-container');
            addNewTab($container);
        });

        $(document).on('click', '.tngp-aggregation-toggle .btn', function (e) {
            e.preventDefault();
            var $btn = $(this);
            var agg = $btn.data('aggregation');
            var $block = $btn.closest('.tngp-cruscotto-block');
            if (!agg || !$block.length) {
                return;
            }
            $block.attr('data-aggregation', agg);
            $block.find('.tngp-aggregation-toggle .btn').removeClass('active');
            $btn.addClass('active');
            var blockId = $block.data('tngpBlockId');
            if (blockId) {
                localStorage.setItem('tngp-agg-' + blockId, agg);
            }
            scheduleAutoResize();
        });

        $(document).on('dblclick', '.dashboard-v2-tab-label', function () {
            if (!isEditMode) {
                return;
            }
            renameTab($(this));
        });

        if (config.tngpDrilldownUrl) {
            $(document).on('click', '.tngp-matrix-cell-drilldown', function (e) {
                e.preventDefault();
                var $link = $(this);
                var params = {
                    metric: $link.data('metric'),
                    year: $link.data('year'),
                    company: $link.data('company') || (config.filterParams && config.filterParams.company) || ''
                };
                if ($link.data('month')) {
                    params.month = $link.data('month');
                }
                if ($link.data('quarter')) {
                    params.quarter = $link.data('quarter');
                }
                if ($link.data('product-id')) {
                    params.product_id = $link.data('product-id');
                }

                var $modal = $('#tngp-drilldown-modal');
                var $loading = $('#tngp-drilldown-loading');
                var $tableWrap = $('#tngp-drilldown-table-wrap');
                var $empty = $('#tngp-drilldown-empty');
                var $tbody = $('#tngp-drilldown-table tbody');

                $tbody.empty();
                $loading.show();
                $tableWrap.hide();
                $empty.hide();
                $modal.modal('show');

                $.get(config.tngpDrilldownUrl, params).done(function (data) {
                    $loading.hide();
                    var rows = (data && data.rows) ? data.rows : [];
                    if (!rows.length) {
                        $empty.show();
                        return;
                    }
                    rows.forEach(function (row) {
                        var amount = row.amount != null
                            ? Number(row.amount).toLocaleString('it-IT', { maximumFractionDigits: 0 })
                            : '';
                        var href = safeProjectHref(row.project_url);
                        var ccHtml = href
                            ? '<a href="' + escapeHtml(href) + '" target="_blank">' + escapeHtml(row.cc || '') + '</a>'
                            : escapeHtml(row.cc || '');
                        $tbody.append(
                            '<tr>' +
                            '<td>' + ccHtml + '</td>' +
                            '<td>' + (row.client || '') + '</td>' +
                            '<td>' + (row.description || '') + '</td>' +
                            '<td class="text-right">' + amount + '</td>' +
                            '<td>' + (row.status || '') + '</td>' +
                            '</tr>'
                        );
                    });
                    $tableWrap.show();
                }).fail(function () {
                    $loading.hide();
                    $empty.text('Errore caricamento dettaglio').show();
                });
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
